const Contact = () => {
    return (
        <>
        <div className='grid grid-cols-1 gap-6 mt-5 mx-5'>
        <div>
        <h3 className="text-4xl font-bold">My Contact</h3>
        <br/>
            <p><b>Phone:</b> +353 83 903 23245</p>
            <p><b>E-mail:</b> justin@gmail.com</p>
            <br/>
        </div>
        </div>
        </>
    );
};

export default Contact;